import { render, staticRenderFns } from "./TheFooterNewsletterForm.vue?vue&type=template&id=4b68e1c0&scoped=true"
import script from "./TheFooterNewsletterForm.vue?vue&type=script&lang=js"
export * from "./TheFooterNewsletterForm.vue?vue&type=script&lang=js"
import style0 from "./TheFooterNewsletterForm.vue?vue&type=style&index=0&id=4b68e1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68e1c0",
  null
  
)

export default component.exports